<template>
    <div id="main">
         <Title/>
         <Intro/>
         <Chancellor/>
         <PartOfGov/>
         <Coalition/>
         <Forecast/>
         <Events/>
    </div>
</template>

<script>
 
 import Forecast from './Forecast.vue'
 import Events from './Events.vue'
 import PartOfGov from './PartOfGov.vue'
 import Coalition from './Coalition.vue'
 import Chancellor from './Chancellor.vue'
 import Title from './Title.vue'
 import Intro from './Intro.vue'

 export default {
     name: 'Main',
     components: {
        PartOfGov, Coalition, Chancellor,
        Forecast, Events, Title, Intro
     },
     computed: {
         showForecast () {
             return this.$store.getters.forecastChartData && this.$store.getters.forecastChartData.lines.length > 0;
         }
     }
 }
</script>